import { render, staticRenderFns } from "./Bullet.vue?vue&type=template&id=e135d812"
import script from "./Bullet.vue?vue&type=script&lang=js"
export * from "./Bullet.vue?vue&type=script&lang=js"
import style0 from "./Bullet.vue?vue&type=style&index=0&id=e135d812&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports